import React from 'react';
import { SVGPureIcon } from '@/ui';
import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import CreateMcpModal from '@/components/modal/create-wcp';
import Tooltip from '@/ui/tooltip';
import userStore from '@/store/user';

const CreateBtn = observer(({ className, small=false }) => {
  useEffect(() => {
    return () => {
      CreateMcpModal.close();
    }
  }, []);

  return (
    <Tooltip title={small ? "创建智能体" : ""}>
      <div
        onClick={evt => {
          if(!userStore.isUser) {
            userStore.gotoLogin();
            return
          }
          agentPageStore.gotoCreate();
        }}
        className={[
          'h-32px px-12px',
          'vh-center rounded-full bg-white cursor-pointer',
          "border-1px border-solid border-[rgba(0,0,0,0.16)]",
          "hover:bg-[rgba(0,0,0,0.03)]",
          small ? "px-8px" : "",
          className,
        ]}
      >
        <SVGPureIcon name="agent_create" className="size-16px text-black" />
        {
          !small
          ? (
            <span className="text-black text-14px ml-6px whitespace-nowrap">
              创建智能体
            </span>
          )
          : null
        }
      </div>
    </Tooltip>
  );
});

export default CreateBtn;
